export const Industries = () => {
  const items = [
    "Education Platforms",
    "Healthcare Systems",
    "E-commerce Applications",
    "IoT & Smart Systems",
    "Startup Products",
    "Enterprise Solutions"
  ];

  return (
    <section className="py-24 text-center">
      <h2 className="text-4xl font-bold mb-10">
        Industries We Serve
      </h2>

      <p className="text-gray-600 mb-10 max-w-2xl mx-auto">
        We deliver solutions across multiple industries, helping businesses
        transform digitally and scale efficiently.
      </p>

      <div className="flex flex-wrap justify-center gap-6">
        {items.map((i, idx) => (
          <span key={idx} className="px-6 py-3 border rounded-full">
            {i}
          </span>
        ))}
      </div>
    </section>
  );
};